// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"37":"b1f19904","138":"c76c0d38","310":"55c65573","446":"201432a1","862":"f783cd9d","970":"9ad5b156"}[chunkId] + ".chunk.css";
};